import { render, staticRenderFns } from "./CtrlNormalTxt.vue?vue&type=template&id=5b9f6942&scoped=true&"
import script from "./CtrlNormalTxt.vue?vue&type=script&lang=ts&"
export * from "./CtrlNormalTxt.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlNormalTxt.vue?vue&type=style&index=0&id=5b9f6942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f6942",
  null
  
)

export default component.exports